import { MatchProfileRuleSet } from "~enums/matchProfileRuleSet.ts";
import convertFields from "./convertFields";

const DEFAULT_VALUES = {
  basketball: {
    defaultProfile: false,
    overtimeAllowed: false,
    simpleTargetScoreEndingAllowed: false,
    midGameJumpBallAllowed: false,
    pointsFourAllowed: false,
    ruleSet: MatchProfileRuleSet.Fiba,
  },
  ice3: {
    defaultProfile: false,
    overtimeAllowed: false,
  },
  hockey: {
    defaultProfile: false,
    overtimeAllowed: false,
    timeoutsPerMatch: 1,
    tiebreakType: null,
    shotsUntilSuddenDeath: 1,
    shootoutSeconds: 8,
    warmupSeconds: 10,
    shootoutSecondsCountdown: 4,
    countdownTimer: 40,
    greenCardSeconds: 2,
    yellowCardSeconds: 5,
  },
  handball: {
    defaultProfile: false,
    numberOfPeriods: 2,
    periodLength: 30,
    overtimeAllowed: true,
    shootoutIfTie: false,
    overtimeLength: 10,
    maximumRosterSize: 16,
    halfTimeDuration: 15,
    maximumPlayersOnCourt: 7,
    shotsUntilSuddenDeath: 5,
    timeoutsAllowed: 3,
  },
};
const getInitFormValues = ({ sport, matchProfile }) => {
  if (matchProfile) {
    const { name, defaultProfile, profile } = matchProfile;

    const convertedData = convertFields({
      data: profile,
      type: "client",
      sport,
    });

    return {
      name,
      defaultProfile,
      ...convertedData,
    };
  }

  return DEFAULT_VALUES?.[sport];
};

export default getInitFormValues;
